import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@scramble/hooks';
import { useGetMe } from '@/hooks/useGetMe';
import { VeriffForm } from './form';
import s from './index.module.scss';

const id = MODAL_IDS.veriff_modal;

export const VeriffModal = () => {
  const { modalIds, data: props } = useModal();
  const { user } = useGetMe();
  return (
    modalIds[id] && props && user && <Modal id={id} user={user} {...props} />
  );
};

const Modal = ({ id, user, onSuccess, onBack, onClose }) => {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const isMobile = useIsMobile();

  const handleSuccess = veriffProps => {
    onSuccess && onSuccess(veriffProps);
  };

  const form = (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h1 className={s.title}>{t('veriff:title')}</h1>
        <p className={s.desc}>{t('veriff:description')}</p>
      </div>
      <div className={s.content}>
        <div className={s.content_inner}>
          <VeriffForm
            id={id}
            user={user}
            onBack={onBack}
            onSuccess={handleSuccess}
            onClose={onClose}
          />
        </div>
      </div>
      <div className={s.footer}>
        <div id={id} />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {form}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {form}
    </ModalCenterLayout>
  );
};
